import { WarnTypes } from "@/stores";
import { BaseAlert } from "./BaseAlert";

export interface RequestAlertProps {
  type: "under" | "over";
  enteredValue: number;
  targetValue: number;
  company: string;
}

export const RequestAlert = ({
  type,
  enteredValue,
  targetValue,
  company,
}: RequestAlertProps) => {
  const title = type === WarnTypes.UNDER ? "Under Minimum" : "Over Maximum";

  return (
    <BaseAlert type="warn" title={title}>
      {type === WarnTypes.UNDER ? (
        <>
          <p className="text-[18px] ">
            The amount you entered — {enteredValue.toLocaleString()} {company}{" "}
            miles — is below our minimum of {targetValue.toLocaleString()}{" "}
            miles.
          </p>
          <p className="text-[18px] ">
            We have adjusted the quote to reach the minimum requirement.
          </p>
        </>
      ) : (
        <>
          <p className="text-[18px]">
            The amount you entered — {enteredValue.toLocaleString()} {company}{" "}
            miles — exceeds our maximum limit of {targetValue.toLocaleString()}{" "}
            miles.
          </p>
          <p className="text-[18px] ">
            We have adjusted the quote to match the maximum limit.
          </p>
        </>
      )}
    </BaseAlert>
  );
};
